const ADORA_ORG_ID = process.env.REACT_APP_ADORA_ORG_ID;

export function initAdora({ uid, email, plan }) {
  if (!uid || !plan || !ADORA_ORG_ID) {
    return;
  }

  const startAdora = () => {
    if (window.adoraStart) {
      window.adoraStart({
        orgId: ADORA_ORG_ID,
        uid,
        properties: {
          email,
          plan,
        },
      });
    }
  };

  const existingScript = document.getElementById('adora-script');

  if (existingScript) {
    startAdora();

    return;
  }

  const script = document.createElement('script');

  script.id = 'adora-script';
  script.type = 'text/javascript';
  script.src = 'https://adora-cdn.com/adora-start.js';
  script.onload = startAdora;
  document.head.appendChild(script);
}
